import React from "react";
import { useGameStateStore } from "../../../stores/gameStateStore";
import Ball from "../../Ball/Ball";
import "./BigBall.css"


export default function BigBall() {
  const pickedNumbers = useGameStateStore(s => s.pickedNumbers);
  const lastNum = pickedNumbers[pickedNumbers.length - 1];

  return (
    <div className="big-ball-con">
      {lastNum !== undefined && (
        <Ball
          key={lastNum} // bu satır önemli! her sayı değiştiğinde Ball yeniden oluşturulur
          number={lastNum}
          className="big-ball"
          numberClassName="big-ball-number"
        />
      )}
    </div>
  );
}
